export const Footer = () => {
  return (
    <footer className="border-t border-border/50 py-8 sm:py-12 relative">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row items-center justify-between gap-4">
          {/* Logo & Branding */}
          <div className="flex items-center gap-2">
            <div className="w-8 h-8 rounded-lg bg-gradient-to-br from-primary to-primary-glow flex items-center justify-center">
              <span className="text-lg font-bold text-primary-foreground">R</span>
            </div>
            <span className="text-lg font-bold text-foreground font-['Space_Grotesk']">Ref Assist</span>
          </div>
          
          {/* Copyright */}
          <div className="text-sm text-muted-foreground text-center md:text-left">
            © {new Date().getFullYear()} Ref Assist. All rights reserved. Patent pending.
          </div>
        </div>
        
        {/* Subtle Admin Link */}
        <div className="absolute bottom-2 right-4">
          <a 
            href="/admin/waitlist" 
            className="text-xs text-muted-foreground/40 hover:text-muted-foreground transition-colors"
            aria-label="Admin login"
          >
            ·
          </a>
        </div>
      </div>
    </footer>
  );
};
